import { FormControlLabel, Radio, RadioProps } from '@mui/material';
import classNames from 'classnames';
import { FC } from 'react';

import classes from './LabelRadio.module.scss';

export interface LabelRadioProps {
  color:
    | 'info'
    | 'error'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'default';
  label?: string;
  className?: string;
  RadioProps?: RadioProps;
  value?: string | boolean;
}

const LabelRadio: FC<LabelRadioProps> = ({
  color,
  label,
  className,
  RadioProps,
  value,
}) => {
  return (
    <FormControlLabel
      className={classNames(classes.Checkbox, className)}
      value={value}
      control={<Radio {...RadioProps} disableRipple color={color} />}
      label={label}
    />
  );
};

export default LabelRadio;
